import type { PayloadAction } from '@reduxjs/toolkit'
import { RequestActions } from '@store/requestsSaga/actions'
import type { AppState } from '@store/types'
import * as ActionTypes from '@storeOld/actions'
import { closeModal } from '@storeOld/reducers/ui'
import { put, select, take } from 'redux-saga/effects'

import { AuthActions } from '../actions'

export function* setTokenSaga(action: PayloadAction<string>) {
  const token = action.payload

  localStorage.setItem('token', token)

  yield put(RequestActions.fetchAuth({ providedToken: token }))

  // ждём итог fetchAuth — юзер загружен, только теперь закрываем модалку логина,
  // чтобы под ней не мелькал артборд; verify/setup-кейсы заменили содержимое
  // модалки сами, при RESET_AUTH/unavailable стейт пустой — модалка остаётся
  yield take([
    ActionTypes.SET_AUTH,
    ActionTypes.RESET_AUTH,
    AuthActions.unavailable.type,
  ])

  const { emailVerified, setupCompleted }: AppState['auth'] = yield select(
    (state: AppState) => state.auth
  )

  if (emailVerified && setupCompleted) {
    yield put(closeModal())
  }
}
